/*
getDoubleIncAnalysisQuery.js
获取双增公式分析时的query
 */

import {getAllCards} from "../../../Model/DoubleIncIndexedDB/DoubleIncIndexedDB";

const getDoubleIncAnalysisQuery = async () => {
    let query = '在双增公式计算过程，以下是不同建筑的K值数据：'
    const cards = await getAllCards();
    cards.forEach((card) => {
        // 先判断该card是否是一个有效的卡片
        if (card.k === 'K') {
            return;
        }
        const sub_query = `${card.title}建筑中K值为${card.k}%,`
        query += sub_query
    });
    query += '请根据这些数据，按以下格式分析这些建筑的供热效果：\n' +
        '\n' +
        '建筑参数分析：\n' +
        '对每个建筑分别提供K值（拓扑等效系数）的分析。\n' +
        '解释K值的含义(1.同一时间，同样的室外温度t3，同一城市，K值越小越好。2.同一建筑物，K值越小，说明室外温度t3越低，需要的拓扑保温越小)。\n' +
        '供热效果对比：\n' +
        '对比建筑之间的K值差异，分析热量传递的效果和可能的影响因素。\n' +
        '说明哪些建筑的保温较好，哪些较差。\n' +
        '结论：\n' +
        '综合对各建筑的分析，给出关于建筑保温效果的总体结论。\n' +
        '解释K值对供热效率的影响，以及它如何反映建筑设计、热源配置等其他因素的效率。\n' +
        '提供对未来实际应用中的进一步分析建议，例如如何优化建筑供热系统。'
    return query;
};

export default getDoubleIncAnalysisQuery;